import m from "../../../../../@vue_babel-helper-vue-jsx-merge-props@1.4.0/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js";
import { isDef as s } from "../utils/index.js";
import { inherit as c } from "../utils/functional.js";
import { createNamespace as p } from "../utils/create/index.js";
var t = p("info"),
  d = t[0],
  u = t[1];
function n(f, o, l, i) {
  var r = o.dot,
    e = o.info,
    a = s(e) && e !== "";
  if (!(!r && !a)) return f("div", m([{
    class: u({
      dot: r
    })
  }, c(i, !0)]), [r ? "" : o.info]);
}
n.props = {
  dot: Boolean,
  info: [Number, String]
};
var g = d(n);
export { g as default };
